<section id="actualizar-datos" class="actualizar-datos actualizar-datos--session actualizar-datos--v2">
  <microempresario-header></microempresario-header>

  <div id="registro" class="actualizar-datos__body registro--v2">
    <div class="actualizar-datos__shell">
      <header class="actualizar-datos__heading">
        <h1 class="actualizar-datos__title">Actualizar datos</h1>
        <p class="actualizar-datos__persona">{{ subTitle }}</p>
        <p class="actualizar-datos__subtitle">
          Revisa y actualiza la información de tu perfil
        </p>
      </header>

      <div class="actualizar-datos__panel">
        @if (user?.tipoPersona === 'natural') {
          <actualizar-persona-natural></actualizar-persona-natural>
        }
        @if (user?.tipoPersona === 'juridica') {
          <actualizar-persona-juridica></actualizar-persona-juridica>
        }
      </div>
    </div>
  </div>

  <app-home-site-footer></app-home-site-footer>
</section>
